import React from 'react';
import { useAppSelector } from '@doda/pc/src/redux/hooks';
import { loginStatusSelector } from '@doda/common/src/redux/features/memberInfo';
import { QUERY_PARAMS } from '@doda/common/src/constants/queryParams';
import styles from './index.module.scss';

/**
 * PrBannerのProps
 * @param prBannerLinkUrl 遷移先URL
 * @param prBannerImagePath 画像URL
 * @param prBannerJobText 表示テキスト
 */
interface Props {
  prBannerLinkUrl: string;
  prBannerImagePath: string;
  prBannerJobText: string;
}

export const PrBanner: React.FC<Props> = ({
  prBannerLinkUrl,
  prBannerImagePath,
  prBannerJobText,
}) => {
  // 遷移先URL
  const loginStatus = useAppSelector(loginStatusSelector);
  const strLoginStatus = loginStatus ? 'login' : 'logout';
  const url = `${prBannerLinkUrl}/?${QUERY_PARAMS.usrclk_searchList}=PC-${strLoginStatus}JobSearchList_kyujinSearchResultCassetteAreaActiveRecruitment`;

  return (
    <div className={styles.prBanner__Wrapper}>
      <a href={url} target="_blank" rel="noopener">
        <div className={styles.prBanner__textArea}>
          <div className={styles.prBanner__tag}>積極採用中</div>
          <div className={styles.prBanner__text}>{prBannerJobText}</div>
        </div>
        <div className={styles.prBanner__imgArea}>
          <img src={prBannerImagePath} alt="" />
        </div>
      </a>
    </div>
  );
};
